import {
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import AlertType from '../../types/AlertType';

export interface IAlertIcon {
  type: AlertType;
  size: 'sm' | 'lg' | 'inherit';
}

const AlertIcon = (props: IAlertIcon) => {
  let icon;
  switch (props.type) {
    case AlertType.danger:
      icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
      break;
    case AlertType.success:
      icon = <FontAwesomeIcon icon={faCheckCircle} />;
      break;
    case AlertType.info:
    case AlertType.warning:
    default:
      icon = <FontAwesomeIcon icon={faInfoCircle} />;
  }
  return <div className={`alert-icon-${props.size}`}>{icon}</div>;
};

export default AlertIcon;
